// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Mario",
  middleName: "",
  lastName: "Herrero Anaya",
  message:
    "Technology enthusiast specialized in programming and software development.",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/GrumpyArdias",
    },
    // {
    //   image: "fa-facebook",
    //   url: "https://www.facebook.com/",
    // },
    // {
    //   image: "fa-instagram",
    //   url: "https://www.instagram.com/",
    // },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/mario-herrero/",
    },
    // {
    //   image: "fa-twitter",
    //   url: "https://www.twitter.com/",
    // },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/fotoPerfil.png"),
  imageSize: 375,
  message:
    "Technology enthusiast specialized in programming and software development. My main focus is the MERN stack, with backend programming being the part I enjoy the most. I am seeking opportunities where I can apply my knowledge in both development and project management.",
  resume:
    "https://drive.google.com/file/d/1lp8C479EW381LPdW3lYnd-Ko84qh8uCG/view?usp=sharing",
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "grumpyArdias", //i.e."johnDoe12Gh"
  reposLength: 0,
  // Edit this to specific github projects
  specificRepos: [
    "miranda-backoffice",
    "miranda-backend",
    "miranda-laravel",
    "pic-picker",
  ],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    {
      img: require("../editable-stuff/hashirshoaeb.png"),
      label: "First slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum.",
    },
    {
      img: require("../editable-stuff/hashirshoaeb.png"),
      label: "Second slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum.",
    },
  ],
  imageSize: {
    width: "615",
    height: "450",
  },
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "HTML/CSS", value: 90 },
    { name: "JavaScript", value: 95 },
    { name: "React", value: 90 },
    { name: "Node.js", value: 60 },
    { name: "Express", value: 85 },
    { name: "MongoDb", value: 85 },
    { name: "SQL", value: 65 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Self Taught", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I am currently in search of full-time software development opportunities!  If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "info@marioherrero.com",
};

const experiences = {
  show: false,
  heading: "Experiences",
  data: [
    {
      role: "Fullstack Developer", // Here Add Company Name
      companylogo: require("../assets/img/oxygen.jpg"),
      date: "Feb 2023 – Present",
    },
    {
      role: "Project Manager",
      companylogo: require("../assets/img/inelcom.jpg"),
      date: "May 2019 – May 2021",
    },
  ],
};

// Blog SECTION
// const blog = {
//   show: false,
// };

export {
  navBar,
  mainBody,
  about,
  repos,
  skills,
  leadership,
  getInTouch,
  experiences,
};
